// extracted by mini-css-extract-plugin
export default {"homeContainer":"home_homeContainer__tP8UY","threedcontainer":"home_threedcontainer__B5C0l"};